<template>
  <el-dialog
    class="customDialog FilterMarkerTable"
    title="设置筛选条件"
    :visible.sync="dialogVisible"
    :close-on-click-modal = 'false'
    append-to-body
    width="30%"
    :close-on-press-escape = 'false'
  >
    <div class="container">
      <el-button type="primary" @click="add" icon="el-icon-plus">添加一行</el-button>
      <el-button type="default" @click="reset" icon="el-icon-refresh">重 置</el-button>
      <div class="formItem" v-for="(k, index) in conditions" :key="index">
        <el-select v-model="k.propertyId" placeholder="字段名称">
          <el-option
            label="标注名称"
            value="-1">
          </el-option>
          <el-option
            v-for="item in _columns"
            :key="item.value"
            :label="item.label"
            :value="item.prop">
          </el-option>
        </el-select>
        <el-select v-model="k.condition" placeholder="过滤条件">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :disabled="item.value !=='LIKE' && k.propertyId === '-1'"
          >
          </el-option>
        </el-select>
        <el-input v-model="k.value" placeholder="关键字" :maxlength="20" show-word-limit></el-input>
        <el-button type="info" icon="el-icon-minus" @click="deleteRow(index)"></el-button>
      </div>
      <Empty v-if="!conditions.length"></Empty>
    </div>
    <span slot="footer">
      <el-button type="default" @click="close">关 闭</el-button>
      <el-button type="primary" :loading="loading" @click="onSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
// import { exportData } from '@/api/marker'
export default {
  name: 'FilterMarkerTable',
  props: {
    columns: {
      type: Array,
      default: null
    },
    filterParams: {
      type: Array,
      default: () => []
    }
  },
  components: {},
  data () {
    return {
      dialogVisible: false,
      loading: false,
      conditions: [],
      options: [{
        value: 'LIKE',
        label: '包含'
      }, {
        value: 'IS_NULL',
        label: '为空'
      }, {
        value: 'GT',
        label: '大于'
      }, {
        value: 'EQ',
        label: '等于'
      }, {
        value: 'LT',
        label: '小于'
      }]
    }
  },
  computed: {
    _columns () {
      return this.columns
    }
  },
  watch: {
  },
  methods: {
    add () {
      this.conditions.push(
        {
          propertyId: '',
          condition: '',
          value: ''
        }
      )
    },
    open () {
      this.conditions = JSON.parse(JSON.stringify(this.filterParams))
      this.dialogVisible = true
    },
    close () {
      this.dialogVisible = false
    },
    deleteRow (v) {
      this.conditions = this.conditions.filter((item, index) => {
        return index !== v
      })
    },
    reset () {
      this.conditions = []
    },
    onSubmit () {
      this.$emit('updateTable', this.conditions)
      this.dialogVisible = false
    }
  },
  filters: {}
}
</script>

<style lang="scss">
  .FilterMarkerTable{
    .el-dialog__body{
      height: auto;
      min-height: 272px;
      .container{
        .formItem{
          margin-top: 15px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .el-select{
            margin-right: 10px;
          }
          .el-input{
            margin-right: 10px;
          }
        }
      }
    }
  }
</style>
